import {
  getPaymentModesDisplay,
} from '@lba-dev/package.local-globals/encaissementMode';

/**
 * Utility functions for metier handling
 * Shared between UI display and export functions
 */

/**
 * Get metier name from elem (metiersSteps or metiersDevis)
 * Priority: metiersSteps > metiersDevis > infoDesc.desc > empty
 *
 * @param {Object} elem - element with metiersSteps or metiersDevis
 * @returns {string} - the name of the metier or empty string
 */
export const getMetierName = (elem) => {
  if (elem?.metiersSteps?.name) {
    return elem.metiersSteps.name;
  }
  if (elem?.metiersDevis?.name) {
    return elem.metiersDevis.name;
  }
  // Fallback: infoDesc.desc (description de l'intervention)
  return elem?.infoDesc?.desc || '';
};

/**
 * Get the collection type for metier (metiersSteps or metiersDevis)
 *
 * @param {Object} elem - element with metiersSteps or metiersDevis
 * @param {string} metiersStepsCollection - collection name for metiersSteps
 * @param {string} metiersDevisCollection - collection name for metiersDevis
 * @returns {string} - the collection name
 */
export const getMetierCollection = (
  elem, metiersStepsCollection, metiersDevisCollection
) => {
  if (elem?.metiersSteps) {
    return metiersStepsCollection;
  }
  if (elem?.metiersDevis) {
    return metiersDevisCollection;
  }
  return metiersStepsCollection;
};

/**
 * Get payment modes display string
 * @param {Object} elem - intervention element
 * @returns {string} - comma-separated payment mode names or empty
 */
export const getPaymentModes = (elem) => {
  const modes = elem?.encaissementModes || [];
  return getPaymentModesDisplay(modes);
};

/**
 * Check if using infoDesc.desc fallback (not metiersSteps or metiersDevis)
 * @param {Object} elem - intervention element
 * @returns {boolean} - true if using fallback description
 */
export const isUsingFallbackDesc = (elem) => {
  const noMetierSteps = !elem?.metiersSteps;
  const noMetierDevis = !elem?.metiersDevis;
  return noMetierSteps && noMetierDevis;
};

/**
 * Truncate text for UI display (max 4 words + ...)
 * @param {string} text - text to truncate
 * @param {number} maxWords - max words to show (default 4)
 * @returns {string} - truncated text
 */
export const truncateForDisplay = (text, maxWords = 4) => {
  if (!text) {
    return '';
  }
  const words = text.split(/\s+/);
  if (words.length <= maxWords) {
    return text;
  }
  return `${words.slice(0, maxWords).join(' ')}...`;
};
